import { createVue3AppPackage } from './base';
import { configureApp } from './layout';
export default createVue3AppPackage(async () => (await import('../components/oasis-sidebar.vue')).default, (app) => configureApp(app));
